'use client'

import { useSearchParams } from '@/utils/navigation'
import { Button } from '@/components/UiElements'
import Cookies from 'js-cookie'

export default function AuthErrorPage() {
    const searchParams = useSearchParams()
    const reason = searchParams.get('reason')

    const handleRetry = () => {
        // Clear all auth state
        Cookies.remove('neatolabsToken')
        localStorage.clear()
        sessionStorage.clear()
        // Redirect to home to trigger fresh login
        window.location.href = '/'
    }

    const getMessage = () => {
        switch (reason) {
            case 'token_rejected':
                return 'Your authentication token was rejected by the server. This may be due to a configuration issue.'
            default:
                return 'An authentication error occurred.'
        }
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md text-center">
                <h1 className="text-2xl font-bold text-red-600 mb-4">Authentication Error</h1>
                <p className="text-gray-600 mb-6">{getMessage()}</p>
                <p className="text-sm text-gray-500 mb-6">
                    If this issue persists, please contact your administrator.
                </p>
                <Button onClick={handleRetry} type="primary">
                    Clear Session & Retry
                </Button>
            </div>
        </div>
    )
}
